import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileImport } from "react-icons/fa";

const ModuleImportButton = ({ moduleKey, label = "Import", className = "" }) => {
  const navigate = useNavigate();
  return <button type="button" onClick={() => navigate(`/admin/import/${moduleKey}`)} className={`inline-flex items-center justify-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 transition hover:bg-emerald-100 ${className}`}><FaFileImport /> {label}</button>;
};

export default ModuleImportButton;
